import styled from 'styled-components';
import { units } from '@m/alchemy-ui';

export const StyledDarkModeSwitcherContainer = styled.div`
  padding-bottom: ${units(2)};
`;